var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBalanceWallet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.459,
    height: 14.657,
    viewBox: "0 0 15.459 14.657",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.657,12.214v.8a1.629,1.629,0,0,1-1.641,1.641H1.641A1.584,1.584,0,0,1,.477,14.18,1.584,1.584,0,0,1,0,13.016V1.641A1.584,1.584,0,0,1,.477.477,1.584,1.584,0,0,1,1.641,0H13.016A1.584,1.584,0,0,1,14.18.477a1.584,1.584,0,0,1,.477,1.164v.8H7.329A1.629,1.629,0,0,0,5.687,4.084v6.489a1.629,1.629,0,0,0,1.641,1.641ZM7.329,10.573V4.084h8.13v6.489ZM10.592,8.55a1.134,1.134,0,0,0,.859-.363,1.245,1.245,0,0,0,0-1.717,1.134,1.134,0,0,0-.859-.363,1.2,1.2,0,0,0-.878.363,1.2,1.2,0,0,0,0,1.717,1.193,1.193,0,0,0,.878.363Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalanceWallet);
export default __webpack_public_path__ + "static/media/BalanceWallet.5127960e04f2acac447cd95aee1b8de7.svg";
export { ForwardRef as ReactComponent };